<script setup lang="ts"></script>

<template>
  <!--
    Caps the top of the PreFooter card with the same curve as HeroArch (../../Page/HeroArch.vue) —
    dipping down at the centre, level with the page at the edges. Same sizing convention (wider than
    the viewport, centred and clipped) so it keeps its shape across breakpoints. Cropped to just the
    curve's depth (no long skirt) since, unlike the hero transition, there's no parallax overlap to
    cover — the section's own gradient fills everything below.
  -->
  <svg
    class="block h-auto w-[150vw] max-w-none shrink-0 md:w-[2698px]"
    viewBox="0 0 2698 170"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1349 152.177C534.188 152.177 0 0 0 0V170H2698V0C2698 0 2163.81 152.177 1349 152.177Z"
      fill="var(--color-head-office-40)" />
  </svg>
</template>
